import { create } from "zustand";
import { find } from "../services/service";
export const useStoreCommune = create((set) => ({
  loading: false,
  data: [],
  quartier: [],
  communePrestataire: [],
  error: null,
  getData: async (url) => {
    set({
      loading: true,
      data: [],
    });

    try {
      const getItems = await find(url);
      set({
        loading: false,
        data: getItems.data,
      });
    } catch (error) {
      set({
        loading: false,
        data: [],
        error: error?.response?.data?.donnee,
      });
    }
  },
  getQuartier: async (url) => {
    set({
      loading: true,
      quartier: [],
    });

    try {
      const getItems = await find(url);
      set({
        loading: false,
        quartier: getItems.data,
      });
    } catch (error) {
      set({
        loading: false,
        quartier: [],
        error: error?.response?.data?.donnee,
      });
    }
  },
  getCommunePrestataire: async (url) => {
    set({
      loading: true,
      communePrestataire: [],
    });

    try {
      const getItems = await find(url);
      set({
        loading: false,
        communePrestataire: getItems.data,
      });
    } catch (error) {
      set({
        loading: false,
        communePrestataire: [],
        error: error?.response?.data?.donnee,
      });
    }
  },
}));
